import * as React from 'react';
import { Component, createRef } from 'react';
import {
  createSidebar,
  hideSidebar,
  toggleSidebarCollapse,
} from '../../redux/actions/general/sidebar';
import {
  __,
  backendURL,
  dateTimeFrom,
  getActiveStage,
  getURLParam,
  mapStateToProps,
  redirect,
  setTableParams,
  setURLParam,
  transformToListPairs,
} from '../../core/utils';
import * as _ from 'lodash';
import { withRouter } from 'react-router';
import styles from '../../styles/views/specifications/SpecificationSetItems.scss';
import Tooltip from '../../components/Tooltip';
import autobind from 'autobind-decorator';
import { getPreferences, updatePreferences } from '../../redux/actions/profile';
import {
  createGenericSpecification,
  deletePositions,
  deleteSpecificationSetItems,
  filterSpecificationSetItems,
  readSpecificationSet,
  readSpecificationSetDynamicColumns,
  readSpecificationSetItems,
} from '../../redux/actions/table/specification_sets';
import {
  listPossibleAddressBookManufacturers,
  listPossibleAddressBookSuppliers,
} from '../../redux/actions/table/address_book_companies';
import {
  listPossibleSpecificationResponsibleUsers,
  readWorkingSetSpecification,
} from '../../redux/actions/table/working_set_specifications';
import TableSpecificationSetItems from './helpers/TableSpecificationSetItems';
import { hideDropdown } from '../../redux/actions/general/dropdown';
import classNames from 'classnames';
import Dropdown from '../../components/Dropdown';
import ButtonGroup from '../../components/ButtonGroup';
import Button from '../../components/Button';
import {
  enableProjectsDropdown,
  enableStagesDropdown,
  listActiveModules,
} from '../../redux/actions/general/active_modules';
import SpecificationSetsFlyout from '../../flyouts/specification_sets/SpecificationSetsFlyout';
import WorkingSetSpecificationsFlyout from '../../flyouts/working_set_specifications/WorkingSetSpecificationsFlyout';
import { getBOQArea } from '../../redux/actions/table/working_set_boq';
import { downloadFile } from '../../redux/actions/general/downloader';
import { setNotification } from '../../redux/actions/general/notification';
import { setPlusActions } from '../../redux/actions/general/plus';
import queryString from 'query-string';
import {
  hideAlertbox,
  showAlertbox,
} from '../../redux/actions/general/alertbox';

// ICONS
import ArrowLeftMiddleIcon from '../../assets/images/arrow-left-middle-15x15.svg';
import UncheckedIcon from '../../assets/images/unchecked-15x15.svg';
import CheckedIcon from '../../assets/images/checked-15x15.svg';
import ColumnSelectorIcon from '../../assets/images/column-selector-16x16.svg';
import InfoPositiveIcon from '../../assets/images/info-positive-16x16.svg';
import SpecificationsIcon from '../../assets/images/specifications-24x24.svg';
import ArrowDoubleRightSmallIcon from '../../assets/images/arrow-double-right-small-15x15.svg';
import ExportIcon from '../../assets/images/export-15x15.svg';
import AddSpecificationSetTemplateIcon from '../../assets/images/boq-save-as-template-16x16.svg';
import FilterIcon from '../../assets/images/filter-15x15.svg';
import DeleteIcon from '../../assets/images/delete-15x15.svg';
import PrintIcon from '../../assets/images/print-16x16.svg';
import DeliveryIcon from '../../assets/images/delivery-15x15.svg';
import UserIcon from '../../assets/images/user-16x16.svg';
import SpaceAllocationIcon from '../../assets/images/space-allocation-15x15.svg';
import TaskStatusIcon from '../../assets/images/task-status-15x15.svg';
import TagIcon from '../../assets/images/tag-16x16.svg';
import NeutralIcon from '../../assets/images/neutral-15x15.svg';
import {
  listMyCompanyColors,
  listMyCompanyMaterials,
} from '../../redux/actions/companies';
import SharedSpecificationsFlyout from '../../flyouts/working_set_specifications/SharedSpecificationsFlyout';
import ArrowDownSmallIcon from '../../assets/images/arrow-down-small-15x15.svg';
import { readCurrentSetSpecification } from '../../redux/actions/table/current_set_specifications';
import CurrentSetSpecificationsFlyout from '../../flyouts/current_set_specifications/CurrentSetSpecificationsFlyout';
import history from '../../core/history';

@mapStateToProps((state) => ({
  store: state.table['specification_sets'],
  specification_id: _.get(state.table, [
    'working_set_specifications',
    'clicked_row',
  ]),
  current_set_specification_id: _.get(state.table, [
    'current_set_specifications',
    'clicked_row',
  ]),
  user_id: state.auth.id,
  dropdown: state.general.dropdown.shown,
  application_language_id: state.auth.language_id,
}))
@withRouter
class SpecificationSetItems extends Component {
  constructor(props) {
    super(props);

    this.state = {
      focused_id: null,
      space_allocation: {},
      expanded_rows: [],
      isDataLoaded: false,
      active_level: 1,
      levels: [],
      columns: [],
      column_widths: {},
      my_company_colors: [],
      my_company_materials: [],
      specification_set_id:
        _.toNumber(getURLParam('external_company')) ||
        this.props.match.params.specification_set,
    };

    this.tableRef = createRef();
    this.nameRefs = [];

    this.savePreferencesTimeout = null;
  }

  _isCurrentSetSource() {
    return _.includes(
      this.props.location.pathname,
      '/specifications/current/sets/'
    );
  }

  _getItemsSource() {
    return this._isCurrentSetSource() ? 'current_set' : null;
  }

  _readSpecificationSetItems(
    specification_set_id = this.state.specification_set_id
  ) {
    return readSpecificationSetItems(
      specification_set_id,
      this._getItemsSource()
    );
  }

  @autobind
  _refreshSpecificationSetItems() {
    this._readSpecificationSetItems(this.state.specification_set_id);

    hideDropdown();
  }

  componentDidMount() {
    const is_current_set_source = this._isCurrentSetSource();

    enableProjectsDropdown(({ stage_id }) =>
      redirect(
        '/stages/' +
          stage_id +
          (is_current_set_source
            ? '/specifications/current'
            : '/specifications/sets')
      )
    );
    enableStagesDropdown(({ stage_id }) =>
      redirect(
        '/stages/' +
          stage_id +
          (is_current_set_source
            ? '/specifications/current'
            : '/specifications/sets')
      )
    );

    // getStagesLanguages(this.props.match.params.stage).then(({ response }) => {
    //   setTableParams('specification_sets', {
    //     project_languages: response.data,
    //     language_id: _.findKey(response.data, (primary) => primary == true),
    //   });
    // });

    readSpecificationSet(this.props.match.params.specification_set);

    setTableParams('specification_sets', {
      disabled_columns: [],
    });

    readSpecificationSetDynamicColumns(this.state.specification_set_id).then(
      () => {
        this._readSpecificationSetItems(this.state.specification_set_id)
          .then(({ response }) => {
            listActiveModules();
            this.setState({ preview: response.data, isDataLoaded: true });
          })
          .then(() => {
            getPreferences(
              `table.specification_set_items.${this.props.match.params.specification_set}`
            )
              .then(({ response: { data } }) => {
                const expanded_rows = _.get(data, 'expanded_rows', []);
                const column_widths = _.get(data, 'column_widths', {});

                this.tableRef.setExpandedRowKeys(expanded_rows);
                this.setState({ expanded_rows, column_widths });

                this.setState({ columns: this.tableRef.props?.columns });

                const user_preference_params = _.transform(
                  data,
                  (params, value, key) => {
                    if (_.startsWith(key, 'filter_')) {
                      params[key.replace('filter_', 'filter.')] =
                        _.toString(value);
                    } else {
                      params[key] = value;
                    }
                  },
                  {}
                );

                setTableParams(
                  'specification_sets',
                  _.pick(user_preference_params, [
                    'disabled_columns',
                    'pinned_columns',
                    'view',
                  ])
                );

                this.setState({
                  expanded_rows,
                  column_widths,
                  tempDisabledColumns: user_preference_params.disabled_columns,
                });

                const url_parameters = queryString.parse(
                  this.props.history.location.search
                );

                const filterParams = _.pickBy(url_parameters, (value, key) =>
                  _.startsWith(key, 'filter.')
                );

                if (!_.isEmpty(filterParams)) {
                  _.forEach(filterParams, (value, key) => {
                    setTableParams('specification_sets', { [key]: value });
                  });

                  this._filterSpecificationSetItems();
                }
              })
              .then(() => {
                const levels = {
                  2: [],
                  3: [],
                };

                _.each(this.props.store.items, (group) => {
                  !_.isEmpty(group.children) && levels[2].push(group.id);

                  _.each(group.children, (subgroup) => {
                    !_.isEmpty(subgroup.children) &&
                      levels[3].push(subgroup.id);
                  });
                });

                this.setState({ levels });

                for (let i = 2; i <= 3; i++) {
                  if (
                    _.every(levels[i], (id) =>
                      _.includes(this.state.expanded_rows, id)
                    )
                  ) {
                    this.setState({ active_level: i });
                  }
                }
              });
          });
      }
    );

    listPossibleAddressBookManufacturers().then(({ response }) => {
      this.setState({
        possible_address_book_manufacturers: transformToListPairs(
          response.data
        ),
      });
    });

    listPossibleAddressBookSuppliers().then(({ response }) => {
      this.setState({
        possible_address_book_suppliers: transformToListPairs(response.data),
      });
    });

    listPossibleSpecificationResponsibleUsers(
      this.props.match.params.stage
    ).then(({ response }) => {
      this.setState({
        possible_specification_responsible_users: transformToListPairs(
          response.data
        ),
      });
    });

    listMyCompanyColors().then(({ response }) => {
      this.setState({ my_company_colors: response.data });
    });

    listMyCompanyMaterials().then(({ response }) => {
      this.setState({ my_company_materials: response.data });
    });

    getBOQArea(this.props.match.params.stage).then(({ response }) => {
      this.setState({ space_allocation: response.data });
    });

    if (!is_current_set_source) {
      const plus_actions = [
        {
          label: __('specification-set-item.label.add-generic-specification'),
          tooltip: __(
            'specification-set-item.tooltip.add-generic-specification'
          ),
          disabled: false,
          onClick: () => this._createGenericSpecification(),
        },
        {
          label: __('specification-set.label.add-specification'),
          tooltip: __('specification-set.tooltip.add-specification'),
          disabled: false,
          onClick: () => this._addSpecification(),
        },
        {
          label: __('specification-set.label.add-existing-specifications'),
          tooltip: __('specification-set.tooltip.add-existing-specifications'),
          disabled: false,
          onClick: () => this._addExistingSpecifications(),
        },
      ];

      setPlusActions(
        _.map(plus_actions, (button, i) => {
          return {
            name: button.label,
            onClick: () => button.onClick(),
            disabled: button.disabled,
          };
        })
      );

      hideSidebar();
    }
  }

  @autobind
  _saveTablePreferences() {
    if (this.savePreferencesTimeout) clearTimeout(this.savePreferencesTimeout);

    this.savePreferencesTimeout = setTimeout(() => {
      updatePreferences(
        `table.specification_set_items.${this.props.match.params.specification_set}`,
        {
          expanded_rows: this.state.expanded_rows,
        }
      );
    }, 1000);
  }

  @autobind
  _handleColumnResizeEnd(columnKey, width) {
    if (!columnKey) {
      return;
    }

    this.setState(
      (prevState) => ({
        column_widths: {
          ...prevState.column_widths,
          [columnKey]: width,
        },
      }),
      () => {
        updatePreferences(
          `table.specification_set_items.${this.props.match.params.specification_set}`,
          {
            column_widths: this.state.column_widths,
          }
        );
      }
    );
  }

  @autobind
  _resetColumnsToDefault() {
    this.setState({
      tempDisabledColumns: _.map(
        _.filter(this.state.columns, ({ active }) => !active),
        'key'
      ),
    });
  }

  @autobind
  _createGenericSpecification(specification_subgroup_id) {
    if (specification_subgroup_id) {
      return createGenericSpecification(
        this.props.match.params.specification_set,
        {
          specification_subgroup_id,
        }
      ).then(() => {
        this._refreshSpecificationSetItems();
      });
    }

    return setTableParams('specification_sets', {
      create_generic_specification_wizard_active: true,
    });
  }

  @autobind
  _addSpecification(specification_subgroup_id = null) {
    setTableParams('working_set_specifications', {
      wizard_active: true,
      specification_subgroup_id,
    });
  }

  @autobind
  _addExistingSpecifications() {
    setTableParams('specification_sets', {
      add_existing_specifications_to_set_wizard_active: true,
    });
  }

  @autobind
  _toggleFilterFlyout() {
    setTableParams('specification_sets', {
      showFilters: !this.props.store.showFilters,
    });
  }

  @autobind
  _filterSpecificationSetItems() {
    filterSpecificationSetItems();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.store.initialItemsData &&
      this.props.store.initialItemsData !== prevProps.store.initialItemsData &&
      this.state.active_level > 1 &&
      this.tableRef
    ) {
      const levels = {
        2: [],
        3: [],
      };
      _.each(this.props.store.initialItemsData, (group) => {
        !_.isEmpty(group.children) && levels[2].push(group.id);
        _.each(group.children, (subgroup) => {
          !_.isEmpty(subgroup.children) && levels[3].push(subgroup.id);
        });
      });

      const expanded_rows =
        this.state.active_level == 2 ? levels[2] : [...levels[2], ...levels[3]];

      this.setState({ expanded_rows, levels });

      this._saveTablePreferences();

      this.tableRef.setExpandedRowKeys(expanded_rows);
    }

    if (prevState.specification_set_id != this.state.specification_set_id) {
      readSpecificationSetDynamicColumns(this.state.specification_set_id).then(
        () => {
          this._readSpecificationSetItems(this.state.specification_set_id).then(
            ({ response }) => {
              this.setState({ preview: response.data });
            }
          );
        }
      );
    }

    if (
      this.props.store.clicked_row &&
      this.props.store.clicked_row !== prevProps.store.clicked_row
    ) {
      if (!prevProps.store.clicked_row) {
        this.setState({ preview: undefined });
      }

      readSpecificationSet(this.props.store.clicked_row).then(
        ({ response }) => {
          setTableParams('specification_sets', {
            flyout: response.data,
          });
        }
      );
    }
  }

  @autobind
  extractItemsAndPositions(input) {
    const parsed = _.map(input, (str) => _.map(str.split('-'), Number));

    const level2Keys = _.map(
      _.filter(parsed, (p) => p.length === 2),
      (p) => `${p[0]}-${p[1]}`
    );

    const items = _.uniq(
      _.map(
        _.filter(parsed, (p) => p.length === 2),
        (p) => p[1]
      )
    );

    const positions = _.uniq(
      _.map(
        _.filter(
          parsed,
          (p) => p.length === 3 && !_.includes(level2Keys, `${p[0]}-${p[1]}`)
        ),
        (p) => p[2]
      )
    );

    return {
      items,
      positions,
    };
  }

  getSelectedSpecificationIds(selected_rows) {
    const rowsById = {};

    const walk = (rows) => {
      _.each(rows, (row) => {
        rowsById[row.id] = row;

        if (!_.isEmpty(row.children)) {
          walk(row.children);
        }
      });
    };

    walk(this.props.store.items || []);

    return _.uniq(
      _.compact(
        _.map(selected_rows, (id) => {
          let row = rowsById[id];

          while (row && !row.specification_id) {
            row = rowsById[row.parentId];
          }

          return row?.specification_id;
        })
      )
    );
  }

  getSpecificationSetSpecificationIds(
    rows = this.props.store.initialItemsData || this.props.store.items || []
  ) {
    const specification_ids = [];

    const walk = (rows) => {
      _.each(rows, (row) => {
        row.specification_id && specification_ids.push(row.specification_id);

        if (!_.isEmpty(row.children)) {
          walk(row.children);
        }
      });
    };

    walk(rows);

    return _.uniq(specification_ids);
  }

  @autobind
  _openPrintSpecificationsWizard() {
    setTableParams('working_set_specifications', {
      print_specifications_wizard: 'print_selected',
      print_specifications_source: 'specification_set',
      project_language: this.props.store.flyout?.main_language,
      specification_ids: this.getSpecificationSetSpecificationIds(),
    });
  }

  getSpecificationSetSpecifications(
    rows = this.props.store.initialItemsData || this.props.store.items || []
  ) {
    const specifications = [];

    const walk = (current_rows) => {
      _.each(current_rows, (row) => {
        row.specification_id &&
          specifications.push({
            ..._.omit(row, ['children', 'id', 'code']),
            id: row.specification_id,
            code: row.specification_code,
          });

        if (!_.isEmpty(row.children)) {
          walk(row.children);
        }
      });
    };

    walk(rows);

    return _.uniqBy(specifications, 'id');
  }

  @autobind
  _openDeliveryWizard(specification_ids = []) {
    const valid_specification_ids = _.compact(specification_ids);

    const selected_specifications = _.filter(
      this.getSpecificationSetSpecifications(),
      (specification) => _.includes(valid_specification_ids, specification.id)
    );

    if (_.isEmpty(selected_specifications)) {
      return;
    }

    setTableParams('working_set_specifications', {
      selected_rows: [],
      delivery_wizard_active: true,
      selected_specifications,
    });
  }

  @autobind
  groupActions(selected_rows) {
    const actions = [];

    const { items, positions } = this.extractItemsAndPositions(selected_rows);
    const specification_ids = this.getSelectedSpecificationIds(selected_rows);

    actions.push([
      <Tooltip
        text={__(
          'specification-set-items.tooltip.icon.change-responsible-user-to-selected-specifications'
        )}
        key={_.uniqueId()}
      >
        <UserIcon
          onClick={(e) => {
            e.stopPropagation();

            setTableParams('specification_sets', {
              selected_specification_ids: items,
              edit_specifications_responsible_user_wizard: true,
            });
          }}
        />
      </Tooltip>,

      <Tooltip
        text={__(
          'specification-set-items.tooltip.icon.add-area-to-selected-specifications'
        )}
        key={_.uniqueId()}
      >
        <SpaceAllocationIcon
          onClick={(e) => {
            e.stopPropagation();

            setTableParams('specification_sets', {
              selected_specification_ids: items,
              edit_specifications_area_wizard: true,
            });
          }}
        />
      </Tooltip>,

      <Tooltip
        text={__(
          'specification-set-items.tooltip.icon.change-status-to-selected-specifications'
        )}
        key={_.uniqueId()}
      >
        <TaskStatusIcon
          onClick={(e) => {
            e.stopPropagation();

            setTableParams('specification_sets', {
              selected_specification_ids: items,
              edit_specifications_status_wizard: true,
            });
          }}
        />
      </Tooltip>,

      !_.isEmpty(specification_ids) && (
        <Tooltip
          text={__(
            'specifications.working-set.group-actions.multiple-edit-tags'
          )}
          key={_.uniqueId()}
        >
          <TagIcon
            onClick={(e) => {
              e.stopPropagation();

              setTableParams('specification_sets', {
                multiple_specification_tags_edit_wizard: specification_ids,
              });
            }}
          />
        </Tooltip>
      ),

      !_.isEmpty(specification_ids) && (
        <Tooltip
          text={__(
            'specifications.working-set.flyout.deliver-specification.create-delivery'
          )}
          key={_.uniqueId()}
        >
          <DeliveryIcon
            onClick={(e) => {
              e.stopPropagation();

              this._openDeliveryWizard(specification_ids);
            }}
          />
        </Tooltip>
      ),

      <Tooltip
        text={__(
          'specification-set-items.tooltip.icon.delete-selected-specifications'
        )}
        key={_.uniqueId()}
      >
        <DeleteIcon
          onClick={(e) => {
            e.stopPropagation();

            showAlertbox({
              color: 'red',
              title: __('general.alert.are-you-sure'),
              description: __(
                'specification-set-items.alert.delete-confirmation'
              ),
              buttons: [
                {
                  color: 'lightGray',
                  text: __('general.alert.no-close'),
                  onClick: 'close',
                },
                {
                  color: 'gray',
                  text: __('general.alert.yes-delete'),
                  onClick: () => {
                    deleteSpecificationSetItems(items).then(() => {
                      deletePositions(positions).then(() => {
                        setNotification(__('quantity.alert.deleted'));

                        this._readSpecificationSetItems(
                          this.props.match.params.specification_set
                        );
                      });
                    });

                    hideAlertbox();
                  },
                },
              ],
            });
          }}
        />
      </Tooltip>,
    ]);

    return actions;
  }

  @autobind
  _toggleColumn(column) {
    this.setState({
      tempDisabledColumns: _.xor(this.state.tempDisabledColumns, [column]),
    });
  }

  @autobind
  _toggleAllColumns() {
    if (_.isEmpty(this.state.tempDisabledColumns)) {
      this.setState({
        tempDisabledColumns: _.map(
          _.filter(this.state.columns, (column) => !column.required),
          'key'
        ),
      });
    } else {
      this.setState({
        tempDisabledColumns: [],
      });
    }
  }

  @autobind
  _goBack() {
    // if (this._isCurrentSetSource()) {
    //   return redirect(
    //     '/stages/' + getActiveStage() + '/specifications/current?filter.subgroup='
    //   );
    // }

    // window.previousLocation
    //   ? window.history.back()
    //   : redirect('/stages/' + getActiveStage() + '/specification-sets');

    history.goBack();
  }

  @autobind
  _setURLParams(params) {
    const search = queryString.stringify({
      ...queryString.parse(this.props.history.location.search),
      ...params,
    });
    redirect({ search }, true);
  }

  render() {
    const {
      space_allocation,
      expanded_rows,
      focused_id,
      possible_address_book_manufacturers,
      possible_address_book_suppliers,
      possible_specification_responsible_users,
      active_level,
      levels,
      column_widths,
      tempDisabledColumns,
      my_company_colors,
      my_company_materials,
      specification_set_id,
      isDataLoaded,
    } = this.state;

    const {
      project_currency,
      flyout,
      items,
      dynamic_columns,
      disabled_columns,
    } = this.props.store;
    const {
      localization,
      dropdown,
      specification_id,
      current_set_specification_id,
      user_id,
      application_language_id,
    } = this.props;
    const is_current_set_source = this._isCurrentSetSource();

    const footer_buttons = [
      {
        label: __('specification-set-item.label.add-generic-specification'),
        tooltip: __('specification-set-item.tooltip.add-generic-specification'),
        disabled: false,
        onClick: () => this._createGenericSpecification(),
      },
      {
        label: __('specification-set.label.add-specification'),
        tooltip: __('specification-set.tooltip.add-specification'),
        disabled: false,
        onClick: () => this._addSpecification(),
      },
      {
        label: __('specification-set.label.add-existing-specifications'),
        tooltip: __('specification-set.tooltip.add-existing-specifications'),
        disabled: false,
        onClick: () => this._addExistingSpecifications(),
      },
    ];

    const specification_action_row = [
      {
        label: __('specification-set-item.button.add-generic-specification'),
        onClick: (specification_subgroup_id) =>
          this._createGenericSpecification(specification_subgroup_id),
      },
      {
        label: __('specification-set-item.button.add-specification'),
        onClick: (specification_subgroup_id) =>
          this._addSpecification(specification_subgroup_id),
      },
    ];

    const is_administrator = _.isObject(
      _.find(flyout?.administrators, ['id', user_id])
    );

    const filters = _.reject(
      _.map(this.props.store.item_filters, (filter, key) => {
        return {
          key: key,
          name: filter.name,
          type: filter.type,
          nullable: filter.nullable,
          pinned: _.get(this.props.store.pinned_columns, key),
          items: _.map(filter.items, (value, key) => {
            return {
              value: key,
              label: value,
            };
          }),
          defaultItems: _.map(filter.defaultItems, (value, key) => {
            return {
              value: key,
              label: value,
            };
          }),
        };
      }),
      (filter) =>
        filter.type == 'sidebar' ||
        (filter.type == 'select' && _.isEmpty(filter.items))
    );

    const total_specifications = _.sumBy(this.props.store.items, (item) =>
      _.size(item.children)
    );
    const specification_set_specification_ids =
      this.getSpecificationSetSpecificationIds();

    if (!isDataLoaded) {
      return <></>;
    }

    return (
      <div className={styles.wrapper}>
        <div className={styles.table}>
          <div className={styles.header}>
            <div className={styles.title}>
              <div className={styles.set}>
                <span>
                  <strong>
                    {'IS-' + _.padStart(flyout?.identifier, 4, '0')}:
                  </strong>
                  {_.get(flyout?.title, application_language_id)}
                </span>
              </div>
              {flyout?.start_date && (
                <div className={styles.details}>{`${dateTimeFrom(
                  flyout?.start_date
                )} - ${dateTimeFrom(flyout?.end_date)}`}</div>
              )}
            </div>
            <div className={styles.toolbar}>
              <div className={styles.left} onClick={this._goBack}>
                <ArrowLeftMiddleIcon />{' '}
                {__('specification-sets.tools.back-to-specification-set-list')}
              </div>
              <div className={styles.right}>
                {!is_current_set_source && (
                  <Tooltip
                    text={__(
                      'specification-sets.tooltip.icon.specification-set-template'
                    )}
                  >
                    <AddSpecificationSetTemplateIcon
                      className={styles.template}
                      onClick={() =>
                        setTableParams('specification_sets', {
                          add_specification_set_template_wizard_active: true,
                        })
                      }
                    />
                  </Tooltip>
                )}

                {!is_current_set_source && <div className={styles.separator} />}

                {!is_current_set_source && (
                  <Tooltip
                    text={__(
                      'specification-sets.tooltip.icon.export-specification-set'
                    )}
                    key={_.uniqueId()}
                  >
                    <ExportIcon
                      className={styles.export}
                      onClick={(e) => {
                        e.stopPropagation();

                        setNotification(
                          __(
                            'specification-sets.notification.export-specification-set'
                          )
                        );

                        downloadFile(
                          backendURL + '/specifications/sets/export',
                          {
                            specification_set_id:
                              this.props.match.params.specification_set,
                          }
                        );
                      }}
                    />
                  </Tooltip>
                )}

                {!is_current_set_source && <div className={styles.separator} />}

                {!is_current_set_source &&
                  !_.isEmpty(specification_set_specification_ids) && (
                    <>
                      <Tooltip
                        text={__(
                          'specifications.working-set-specifications.print-all-specifications'
                        )}
                      >
                        <PrintIcon
                          className={styles.print}
                          onClick={(e) => {
                            e.stopPropagation();

                            this._openPrintSpecificationsWizard();
                          }}
                        />
                      </Tooltip>

                      <div className={styles.separator} />
                    </>
                  )}

                {!is_current_set_source && (
                  <Tooltip
                    text={__(
                      'specification-sets.tooltip.icon.specification-set-properties'
                    )}
                  >
                    <InfoPositiveIcon
                      className={styles.info}
                      onClick={() =>
                        setTableParams('specification_sets', {
                          clicked_row: flyout.id,
                          stage_id: this.props.match.params.stage,
                        })
                      }
                    />
                  </Tooltip>
                )}
              </div>
            </div>
          </div>

          <div className={styles.heading}>
            <div className={styles.title}>
              <span>
                {__(
                  'specification-set.items.specification-set' + flyout?.status
                )}
              </span>
            </div>

            <div className={styles.details}>
              {is_administrator && !is_current_set_source && (
                <Dropdown
                  top={25}
                  right={-15}
                  wrapperClassName={styles.dropdownWrapper}
                  name={'foreign_company'}
                  header={
                    <div className={styles.dropdownHeader}>Foreign company</div>
                  }
                  content={
                    <div className={styles.dropdownContent}>
                      <div
                        className={classNames(
                          styles.option,
                          this.state.specification_set_id == flyout.id &&
                            styles.active
                        )}
                        onClick={(e) => {
                          this.setState({ specification_set_id: flyout.id });

                          this._setURLParams({ external_company: '' });

                          hideDropdown();
                        }}
                      >
                        <span>
                          {__('specification-sets.dropdown.my-schedule')}
                        </span>

                        <span className={styles.dot} />
                      </div>
                      {_.map(
                        _.groupBy(flyout?.foreign_editors, 'company'),
                        (foreign_editors, company) => (
                          <div
                            key={company}
                            className={classNames(
                              styles.option,
                              this.state.specification_set_id ==
                                _.first(foreign_editors).model_id &&
                                styles.active
                            )}
                            onClick={(e) => {
                              const specification_set_id =
                                _.first(foreign_editors).model_id;

                              this._setURLParams({
                                external_company: specification_set_id,
                              });

                              this.setState({ specification_set_id });

                              hideDropdown();
                            }}
                          >
                            <span>{company}</span>
                            <span className={styles.dot} />
                          </div>
                        )
                      )}
                    </div>
                  }
                >
                  <div className={styles.dropdown}>
                    {specification_set_id ? (
                      <span>
                        {_.get(
                          _.find(flyout?.foreign_editors, [
                            'model_id',
                            specification_set_id,
                          ]),
                          'company'
                        ) || __('specification-sets.dropdown.my-schedule')}
                      </span>
                    ) : (
                      <span className={styles.none}>
                        {__('specification-sets.dropdown.my-schedule')}
                      </span>
                    )}
                    <ArrowDownSmallIcon />
                  </div>
                </Dropdown>
              )}
              <div className={styles.target}>
                <SpecificationsIcon className={styles.icon} />
                <Tooltip
                  text={__(
                    'specification-sets.tooltip.icon.specification-set-properties'
                  )}
                >
                  <span
                    onClick={() =>
                      !is_current_set_source &&
                      setTableParams('specification_sets', {
                        clicked_row: flyout.id,
                        stage_id: this.props.match.params.stage,
                      })
                    }
                  >
                    {'IS-' + _.padStart(flyout?.identifier, 4, '0')}
                    <ArrowDoubleRightSmallIcon />
                  </span>
                </Tooltip>
              </div>

              {!is_current_set_source && !_.isEmpty(filters) && (
                <div className={styles.filter}>
                  <Tooltip text={__('content.tooltip.table.filters')}>
                    <FilterIcon onClick={this._toggleFilterFlyout} />
                  </Tooltip>
                </div>
              )}

              {dynamic_columns && !is_current_set_source && (
                <div className={styles.columnSelector}>
                  <Dropdown
                    closable={false}
                    top={29}
                    right={-19}
                    name='column_selector'
                    header={
                      <div className={styles.columnSelectorHeader}>
                        {__('table.columns.select-columns')}

                        {!_.isEmpty(tempDisabledColumns) &&
                          _.size(tempDisabledColumns) !==
                            _.size(
                              _.filter(
                                this.state.columns,
                                (column) => !column.required
                              )
                            ) && (
                            <NeutralIcon
                              onClick={this._toggleAllColumns}
                              className={styles.neutral}
                            />
                          )}
                        {_.size(tempDisabledColumns) ===
                          _.size(
                            _.filter(
                              this.state.columns,
                              (column) => !column.required
                            )
                          ) && (
                          <UncheckedIcon
                            onClick={this._toggleAllColumns}
                            className={styles.unchecked}
                          />
                        )}
                        {_.isEmpty(tempDisabledColumns) && (
                          <CheckedIcon
                            onClick={this._toggleAllColumns}
                            className={styles.checked}
                          />
                        )}
                      </div>
                    }
                    content={
                      <div className={styles.columnSelectorContent}>
                        {_.map(
                          _.filter(
                            this.state.columns,
                            ({ required, key }) =>
                              !required && key != 'placeholder'
                          ),
                          ({ title, key }) => (
                            <div
                              onClick={() => this._toggleColumn(key)}
                              key={key}
                              className={styles.column}
                            >
                              {title}

                              {_.includes(
                                this.state.tempDisabledColumns,
                                key
                              ) && (
                                <UncheckedIcon className={styles.unchecked} />
                              )}
                              {!_.includes(
                                this.state.tempDisabledColumns,
                                key
                              ) && <CheckedIcon className={styles.checked} />}
                            </div>
                          )
                        )}
                        <div
                          onClick={this._resetColumnsToDefault}
                          className={styles.column}
                        >
                          {__('table.columns.reset-to-default')}
                        </div>
                        <div className={styles.saveFooter}>
                          <ButtonGroup right>
                            <Button
                              lightGray
                              medium
                              middleText={__('button.cancel')}
                              onClick={() => {
                                hideDropdown();
                              }}
                            />
                            <Button
                              lightBlue
                              medium
                              middleText={__('button.done')}
                              onClick={() => {
                                setTableParams('specification_sets', {
                                  disabled_columns:
                                    _.size(this.state.tempDisabledColumns) > 0
                                      ? this.state.tempDisabledColumns
                                      : null,
                                });

                                this._readSpecificationSetItems(
                                  this.props.match.params.specification_set
                                );

                                hideDropdown();
                              }}
                            />
                          </ButtonGroup>
                        </div>
                      </div>
                    }
                  >
                    <Tooltip text={__('content.tooltip.table.columns')}>
                      <ColumnSelectorIcon />
                    </Tooltip>
                  </Dropdown>
                </div>
              )}
            </div>
          </div>

          <TableSpecificationSetItems
            name='specification_set_items'
            title={__('specification_set_items')}
            localization={localization}
            languageId={flyout?.main_language}
            projectCurrency={project_currency}
            focusedId={focused_id}
            data={items}
            dynamicColumns={dynamic_columns}
            disabledColumns={disabled_columns}
            columnWidths={column_widths}
            onColumnResizeEnd={this._handleColumnResizeEnd}
            spaceAllocationData={space_allocation}
            setFocusedId={(focused_id) => this.setState({ focused_id })}
            setRef={(ref) => (this.tableRef = ref)}
            tableRef={this.tableRef}
            expandedRows={expanded_rows}
            setActiveLevel={(active_level) => {
              this.setState({ active_level });
            }}
            setExpandedRows={(expanded_rows) => {
              this.setState({ expanded_rows });

              this._saveTablePreferences();
            }}
            setNameRef={(id, ref) => (this.nameRefs[id] = ref)}
            possible_address_book_manufacturers={
              possible_address_book_manufacturers
            }
            possible_address_book_suppliers={possible_address_book_suppliers}
            possible_specification_responsible_users={
              possible_specification_responsible_users
            }
            refreshData={this._refreshSpecificationSetItems}
            specificationActionRow={
              is_current_set_source ? [] : specification_action_row
            }
            dropdown={dropdown}
            disabled={
              is_current_set_source ||
              _.includes(['closed', 'canceled'], flyout?.status) ||
              specification_set_id != flyout?.id
            }
            filterData={this._filterSpecificationSetItems}
            active_level={active_level}
            levels={levels}
            groupActions={is_current_set_source ? null : this.groupActions}
            openDeliveryWizard={this._openDeliveryWizard}
            selectedRows={
              is_current_set_source ? [] : this.props.store.selected_rows
            }
            my_company_colors={my_company_colors}
            my_company_materials={my_company_materials}
            flyout={flyout}
            readOnlyView={is_current_set_source}
            hideFilter={is_current_set_source}
            onOpenSpecification={
              is_current_set_source
                ? (specification_id) => {
                    readCurrentSetSpecification(specification_id).then(
                      ({ response }) => {
                        setTableParams('current_set_specifications', {
                          flyout: response.data,
                          clicked_row: response.data.id,
                        });
                      }
                    );
                  }
                : null
            }
          />
        </div>

        {!is_current_set_source &&
          is_administrator &&
          this.state.specification_set_id == flyout.id && (
            <div className={styles.footer}>
              {_.map(footer_buttons, (button, i) => (
                <div
                  className={classNames(
                    styles.item,
                    classNames(button.disabled && styles.disabled)
                  )}
                  key={i}
                  onClick={() => {
                    !button.disabled && button.onClick();
                    hideDropdown();
                  }}
                >
                  <Tooltip text={button.tooltip}>
                    <button>{button.label}</button>
                  </Tooltip>
                </div>
              ))}

              <span className={styles.total}>
                {__('specification-sets.footer.total')}: {total_specifications}
              </span>
            </div>
          )}

        {!is_current_set_source && this.props.store.clicked_row && (
          <div
            className={classNames(
              styles.flyout,
              this.props.store.clicked_row && styles.active
            )}
          >
            <SpecificationSetsFlyout
              data={this.props.store.flyout}
              readAction={(specification_set_id) => {
                return new Promise((resolve) => {
                  readSpecificationSet(
                    this.props.match.params.specification_set
                  ).then(({ response }) => {
                    setTableParams('specification_sets', {
                      flyout: response.data,
                    });

                    this._readSpecificationSetItems(
                      this.props.match.params.specification_set
                    ).then(({ response }) => {
                      resolve(response);
                    });
                  });
                });
              }}
            />
          </div>
        )}

        {!is_current_set_source && specification_id && (
          <div className={styles.flyout}>
            {flyout.is_shared ? (
              <SharedSpecificationsFlyout
                readAction={(specification_id) => {
                  return new Promise((resolve) => {
                    this._readSpecificationSetItems(
                      this.props.match.params.specification_set
                    );
                  });
                }}
              />
            ) : (
              <WorkingSetSpecificationsFlyout
                readAction={(specification_id) => {
                  return new Promise((resolve) => {
                    this._readSpecificationSetItems(
                      this.props.match.params.specification_set
                    );
                  });
                }}
              />
            )}
          </div>
        )}

        {is_current_set_source && current_set_specification_id && (
          <div className={styles.flyout}>
            <CurrentSetSpecificationsFlyout />
          </div>
        )}
      </div>
    );
  }
}

export default SpecificationSetItems;
